import JassEnum from './enum';

/**
 * type mapflag
 */
export default class JassMapFlag extends JassEnum {}
